import { ContactInfo, ExtendedContact } from "types/customer"
import { IoNotifications } from "react-icons/io5"
import { RiBillLine } from "react-icons/ri"
import TooltippedElement from "components/TooltippedElement"
import { useTranslation } from "react-i18next"
import { formatPhoneNumber } from "utils/phoneNumberFormatter"

type Props = {
  entries: (ContactInfo | ExtendedContact)[]
  className?: string
  billing?: boolean
  notification?: boolean
}

const ContactInfoDisplay = ({
  entries,
  className = "",
  billing = false,
  notification = false,
}: Props) => {
  const { t } = useTranslation()
  const tBase = "components.customer.ContactInfoDisplay"
  const tr = (key: string) => t(`${tBase}.${key}`)

  const visible = (entries || []).filter((e) =>
    String((e as ExtendedContact).contact_value || "").trim()
  )

  if (!visible.length) return null
  return (
    <div className={`flex flex-col gap-1 text-sm ${className}`}>
      {visible.map((e, i) => {
        const v = String((e as ExtendedContact).contact_value || "").trim()
        const description = String(
          (e as ExtendedContact).contact_description || ""
        ).trim()
        const type = (e as ExtendedContact).contact_type || ""
        const isBilling = type === "email" && !!(e as ExtendedContact).is_billing
        const isNotif = !!(e as ExtendedContact).is_notification
        const showBillIcon = !!billing && isBilling
        const showNotifIcon = !!notification && isNotif
        const showIcons = showBillIcon || showNotifIcon
        const displayValue = type === "phone" ? formatPhoneNumber(v) : v
        return (
          <div key={i} className="flex flex-wrap items-center gap-2 text-slate-600">
            {showIcons && (
              <span className="inline-flex items-center gap-1.5 shrink-0">
                {showBillIcon && (
                  <TooltippedElement
                    message={tr("Billing")}
                    placement="top"
                    element={
                      <RiBillLine
                        className="text-lg text-emerald-600"
                        aria-label={tr("Billing")}
                      />
                    }
                  />
                )}
                {showNotifIcon && (
                  <TooltippedElement
                    message={tr("Notification")}
                    placement="top"
                    element={
                      <IoNotifications
                        className="text-lg text-blue-500"
                        aria-label={tr("Notification")}
                      />
                    }
                  />
                )}
              </span>
            )}
            {showIcons && <span>•</span>}
            <span className="inline-flex items-center gap-1">
              <span>{displayValue}</span>
            </span>
            {description && (
              <>
                <span>•</span>
                <span>{description}</span>
              </>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default ContactInfoDisplay
